/*
 *  Bootstrap Nice Select Afrikaans (South Africa) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['af-ZA'] = localisation.locales['af'] = {
    formatSearch() {
        return "Soek tans...";
    },
    formatHelpForTagging() {
        return "Om eie etikette te skep, fokus die invoerveld en druk dan 'Enter' of ',' of 'Spasiebalk' om dit by die lys te voeg";
    }
}

export default localisation;